import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

export const DeleteDirector = ({
  isOpen,
  close,
  handleDeleteDirector,
  isLoading,
}: {
  isOpen: boolean;
  close: () => void;
  handleDeleteDirector: () => void;
  isLoading: boolean;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Delete this director?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-lg t-text-text-black">
            Are you sure you want to delete this director?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="t-flex t-justify-end t-gap-3">
            <Button onClick={close}>Cancel</Button>
            <Button
              customType="danger"
              onClick={handleDeleteDirector}
              isLoading={isLoading}
              disabled={isLoading}
            >
              Confirm
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
